// extracted by mini-css-extract-plugin
export var notificationHost = "_mj-0";